import { use } from "react";
import { AuthContext, type IAuthContext } from "react-oauth2-code-pkce";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  Grid,
  Text,
  type GridFlow,
} from "@sede-enterprise/shell-ds-react-framework";
import { Container } from "../../components/SDS/Container";
import LogOutIcon from "../../assets/icons/LogOutIcon";
import "../../styles/App.css";

const SessionExpired: React.FC = () => {
  const { logIn }: IAuthContext = use(AuthContext);
  const { t } = useTranslation();

  const handleLoginAgain = () => {
    sessionStorage.clear();

    if (window.location.search) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    logIn();
  };

  const gridProps = {
    columns: 1,
    height: "auto",
    flow: "row" as GridFlow,
    className: "logout-grid",
  };

  return (
    <Container>
      <Grid {...gridProps}>
        <Grid.Cell>
          <Card className="logout-card">
            {/* Session expired icon */}
            <div
              className="logout-success-icon"
              style={{
                background: "var(--shell-color-semantic-warning, #f59e0b)",
              }}
            >
              <svg width="36" height="36" fill="white" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 5a1 1 0 011 1v4.586l2.707 2.707a1 1 0 01-1.414 1.414l-3-3A1 1 0 0111 13V8a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>

            {/* Title */}
            <Text size="large" className="logout-title">
              {t("auth.sessionExpiredTitle", "You have been logged out")}
            </Text>

            {/* Description */}
            <Text size="medium" className="logout-description">
              {t(
                "auth.sessionExpiredSubtitle",
                "Your session has expired due to inactivity. Please log in again to continue.",
              )}
            </Text>

            {/* Action section */}
            <Card className="logout-action-card">
              <Text size="small" className="logout-action-text">
                {t(
                  "auth.sessionExpiredPrompt",
                  "Click below to sign in and be taken to the home page.",
                )}
              </Text>

              <Button onClick={handleLoginAgain} className="logout-button">
                <LogOutIcon style={{ width: "16px", height: "16px" }} />
                {t("auth.loginAgainButton", "Login Again")}
              </Button>
            </Card>
          </Card>
        </Grid.Cell>
      </Grid>
    </Container>
  );
};

export default SessionExpired;
